<template>
    <span v-text="numberCommaFormat(number) + append_text"></span>
</template>

<script>
export default {
    name: "NumberFormatComponent",
    props: {
        number: {
            type: [Number, String],
            require: true,
        },
        append_text: {
            type: [Number, String],
            require: false,
            default: ''
        },
    },
    methods: {
        numberCommaFormat: function (number) {
            if (isNaN(number)) return '0';

            return number
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                .replace(/-,/, '-');
        },
    },
}
</script>

<style scoped>

</style>
